import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=cc18af32&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=ts&"
export * from "./ColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=cc18af32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc18af32",
  null
  
)

export default component.exports